module.exports = __webpack_public_path__ + "static/media/KHR_MASTER_New_BG_Square_100219.fc663d7e.mp4";